module.exports = __webpack_public_path__ + "img/P3920580NVR.5a900979.jpg";